// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"product-image_imgContainer__nggU4","img":"product-image_img__cX5ZW","unavailable":"product-image_unavailable__4G_Wf"};